import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/",
    meta: {
      title: "工作台",
      permissionKey: "workbench",
      permissionAction: "view",
    },
    redirect: "/workbench",
    component: Layout,
    children: [
      {
        path: "/workbench",
        meta: {
          title: "数据看板",
          parentPath: "/",
          permissionKey: "workbench",
          permissionAction: "view",
        },
        component: () => import("@/views/workbench/index.vue"),
      },
    ],
  },
];

export default routes;
